module.exports = __webpack_public_path__ + "static/media/add-circular-outlined-button.925caa7e.svg";